import axios from "axios";
import Vue from "vue";
import store from "../store";

async function subTenantExist(companyName) {
  //set content
  //request
  const subtenantExists = await axios
    .post(`/Subtenant/exists?companyName=${companyName}`)
    .then((response) => {
      Vue.$log.info(response);
      return response.data;
    })
    .catch((error) => {
      Vue.$log.error(error);
      store.state.visitors.errorMessage = error.message;
      store.state.visitors.showError = true;
      return null;
    });
  return subtenantExists;
}

async function LoadPartnerList() {
  //set content
  //request
  const partnerList = await axios
    .get(`/Subtenant/partnerlist`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Vue.$log.error(error);
      return [];
    });
  return partnerList;
}

async function register(body) {
  body.spamProtectionAnswer.sum = Number(body.spamProtectionAnswer.sum);
  //request
  const subtenantID = await axios
    .post(`/Subtenant`, body)
    .then((response) => {
      // Vue.$log.info(response);
      return response.data;
    })
    .catch(() => {
      //  Vue.$log.error(error);
      return null;
    });

  return subtenantID;
}

export default { subTenantExist, register, LoadPartnerList };
